import React from 'react'
import { auth } from '../api/firebase';

interface TextMessageProps {
  text: string;
  author: string;
  user_id: string;
  prevUserId?: string;
  nextUserId?: string;
}

const GifMessage: React.FC<TextMessageProps> = ({ text, author, user_id, prevUserId, nextUserId }) => {
  const uid = auth.currentUser!.uid;

  const recipientClassName = 'bg-gray-700 self-end rounded-l-xl ';
  const senderClassName = 'bg-blue-500 self-start rounded-r-xl ';

  const notSameSenderAsPrevious = (): boolean => {
    return prevUserId !== user_id;
  }

  const displayAuthor = (): boolean => {
    return uid !== user_id && (!prevUserId || notSameSenderAsPrevious());
  }

  const buildClassName = (): string => {
    let className = '';
    if (user_id === uid) {
      className += recipientClassName
      if (prevUserId !== user_id) className += 'rounded-tr-xl ';
      if (nextUserId !== user_id) className += 'rounded-br-xl ';
    }
    else {
      className += senderClassName
      if (prevUserId !== user_id) className += 'rounded-tl-xl ';
      if (nextUserId !== user_id) className += 'rounded-bl-xl ';
    };

    return className;
  }

  return (
    <div className="bg-none pt-1 font-mono flex flex-col flex-wrap">
      {displayAuthor() && <p className='text-sm mx-1'>{author}</p>}
      <p className={'mb-1 mx-1 px-2 max-w-max break-words whitespace-normal ' +
        buildClassName()
      }>
        {text}
      </p>
    </div >
  );
}

export default GifMessage;
